import { render } from "./CreateAdhocCommissionInvoice.vue?vue&type=template&id=0d4cd996"
import script from "./CreateAdhocCommissionInvoice.vue?vue&type=script&lang=js"
export * from "./CreateAdhocCommissionInvoice.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Amaze-Portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__